import React from 'react';
import styles from './CustomizePageSection.module.less';
import { HeadingText } from '@paypalcorp/pp-react';
import withAnchor from '../../../components/Anchor/withAnchor';

const CustomizeSectionStepHeader = ({ showStepNumbers, contentIndex, title }) => {
  return (
    <div className={styles.title_wrapper}>
      {showStepNumbers && <div className={styles.badge}>{contentIndex}</div>}
      <HeadingText size="lg">{title}</HeadingText>
    </div>
  );
};

export default withAnchor(CustomizeSectionStepHeader);
